import Vue from 'vue';
import flatpickr from 'flatpickr';
import { Czech } from 'flatpickr/dist/l10n/cs.js';
import VueFlatPickr from 'vue-flatpickr-component';
import 'flatpickr/dist/flatpickr.css';

export default ({ app }) => {
	flatpickr.localize(Czech);
};

Vue.use(VueFlatPickr);
